import { useCallback } from 'react'
import { SelectChangeEvent } from '@mui/material'
import { useRecurrenceDispatch } from '../../../providers/StateProvider'

export function useOnChange() {
  const dispatch = useRecurrenceDispatch()

  return useCallback(
    (e: SelectChangeEvent<string>) => {
      const recurrencePeriodType = e.target
        .value as uui.domain.ui.forms.ExtendedRecurrencePeriodType

      dispatch({
        type: 'recurrenceType:change',
        recurrencePeriodType,
      })
    },
    [dispatch],
  )
}
